import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/icons/verified.svg'


const _withScopeId = n => (_pushScopeId("data-v-9acaa200"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-start tw-gap-2 tw-relative" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "verified__icon tw-absolute tw-left-[30px] tw-top-[-10px] tw-w-[24px] tw-h-[24px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-shadow-[0px_0px_10px_0px_#0C0F4A33] tw-bg-white" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-items-start tw-w-full tw-gap-2 tw-mt-4" }
const _hoisted_5 = { class: "tw-text-2xl tw-text-[#0C0F4A] tw-font-semibold tw-leading-6 tw-break-all" }
const _hoisted_6 = { class: "tw-flex tw-items-center tw-justify-start" }
const _hoisted_7 = { class: "tw-flex tw-items-center tw-justify-start tw-gap-2" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "tw-text-[12px] tw-font-[700] tw-text-[#0C0F4A] tw-flex tw-gap-1 tw-items-center tw-px-2 tw-py-1 tw-bg-[#0C0F4A0A] tw-rounded-[8px]"
}
const _hoisted_11 = { class: "tw-w-full tw-flex tw-items-center tw-justify-end" }

import Card from "@/core/components/ui/general/Card.vue";
import ProfileThumbnail from "@/core/uni-components/ProfileThumbnail.vue";
import ChipState from "@/core/components/common/ChipState.vue";
import Text from "@/core/components/ui/general/Text.vue";
import RatingIcon from "@/core/components/icons/RatingIcon.vue";
import CheckGreen from "@/core/components/icons/CheckGreen.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Postcode from "@/core/uni-components/Chips/Postcode.vue";
import CountChip from "@/core/uni-components/Chips/CountChip.vue";
import { computed, ref } from "vue";
import CustomBadge from "@/core/uni-components/CustomBadge.vue";
import { onMounted } from "vue";
import {
  getImageApiUrl,
  getImageStringToImageURL,
  getUserSubSkillList,
} from "@/core/utils/common";
import $axios from "@/core/utils/axios-api-config";
import { USER_STORE } from "@/store/modules/user";
import { WORKSTATION } from "@/store/modules/workstation";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { TRADE_ESTIMATES_TRADE_PASSPORT } from "../../routes";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import { reviewRatingState } from "@/core/models/project-rating";
import { REVIEW_RATING_STORE } from "@/store/modules/review-rating";
import { getCombineSameProjectReview } from "@/core/utils/common";


const __default__ = {
  name: "ContractorDetailsCard",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  contractorDetails: {
    type: Object,
  },
},
  setup(__props) {

const props = __props;
const contractorWorkStationUrl = ref(null);

const store = useStore();
const router = useRouter();
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const getAllSpecialism = computed(
  () => store.getters[`${USER_STORE}/getAllSpecialism`]
);
const getUserSkillList = computed(() => {
  return getUserSubSkillList(
    props.contractorDetails?.user?.userSkills,
    getAllSpecialism.value
  );
});

const getAllProjectReviewList = computed<
  reviewRatingState["allProjectReviewList"]
>(() => store.getters[`${REVIEW_RATING_STORE}/getAllProjectReviewList`]);

const combineSameProjectReview = computed(() =>
  getCombineSameProjectReview(getAllProjectReviewList.value)
);
const getAverageOfAllProjectReview = computed(() => {
  const totalAvg = combineSameProjectReview.value.reduce(
    (totalRating: number, review: any) => {
      totalRating += review.totalAvg || 0;
      return totalRating;
    },
    0
  );
  return totalAvg
    ? Math.round((totalAvg * 100) / combineSameProjectReview.value.length) / 100
    : totalAvg;
});

onMounted(async () => {
  try {
    if (!getAllSpecialism.value.length) {
      await store.dispatch(
        `${USER_STORE}/setAllSpecialismsCategory`,
        activeUserWorkstation.value.id
      );
    }

    contractorWorkStationUrl.value = await getImageStringToImageURL(
      props?.contractorDetails?.profileImage
    );
  } catch (error) {
    console.log();
  }
});

const viewTradePassport = async () => {
  if (props.contractorDetails?.id) {
    await store.dispatch(
      `${TRADE_ESTIMATE_STORE}/viewTradeUserAccount`,
      props.contractorDetails?.id
    );

    router.push({
      name: TRADE_ESTIMATES_TRADE_PASSPORT,
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createBlock(Card, { class: "contractor-details-card !tw-py-4 !tw-px-4 !tw-box-border" }, {
    content: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ProfileThumbnail, { src: contractorWorkStationUrl.value }, null, 8, ["src"]),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.contractorDetails?.name), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Text, {
              variant: "span",
              textColor: "rgba(12, 15, 74, 0.5)",
              textWeigth: "600",
              whiteSpace: "wrap"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.contractorDetails?.user?.userBusinessDetails?.type), 1)
              ]),
              _: 1
            }),
            _createVNode(Postcode, {
              value: __props.contractorDetails?.user?.postcode
            }, null, 8, ["value"]),
            _createVNode(ChipState, { hasCustomLabel: true }, {
              prefix: _withCtx(() => [
                _createVNode(RatingIcon)
              ]),
              "custom-label": _withCtx(() => [
                _createVNode(Text, {
                  variant: "span",
                  textWeight: "400",
                  whiteSpace: "nowrap"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getAverageOfAllProjectReview.value) + "/5 ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            (getUserSkillList.value && getUserSkillList.value.length)
              ? (_openBlock(), _createBlock(CustomBadge, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUserSkillList.value.slice(0, 1), (skill) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "tw-text-[12px] tw-font-[700] tw-text-[#0C0F4A] tw-flex tw-gap-1 tw-items-center tw-px-2 tw-py-1 tw-bg-[#0C0F4A0A] tw-rounded-[8px]",
                        key: skill.id
                      }, [
                        _createVNode(_component_v_icon, { class: "!tw-w-[16px] !tw-h-[16px] tw-rounded-full tw-bg-[#0C0F4A] tw-overflow-hidden" }, {
                          default: _withCtx(() => [
                            (skill?.iconName)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "tw-w-[12px] tw-h-[12px] tag__img",
                                  src: 
                      require('@/assets/category-icons/' +
                        skill?.iconName +
                        '.svg')
                    
                                }, null, 8, _hoisted_8))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("p", null, _toDisplayString(skill?.label), 1)
                      ]))
                    }), 128)),
                    _hoisted_9
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (getUserSkillList.value?.length > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " +" + _toDisplayString(getUserSkillList.value?.length - 1), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_v_divider, { class: "tw-my-4" }),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(Button, {
            onClick: viewTradePassport,
            class: "!tw-w-auto !tw-px-0 !tw-py-0 tw-box-border !tw-text-[#4B4BFF] !tw-capitalize !tw-font-normal !tw-tracking-[0.15px] !tw-h-auto",
            variant: "p",
            label: "View Trade Passport"
          }, {
            postfix: _withCtx(() => [
              _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})